import $ from 'jquery';
import 'slick-carousel';

ready(qs('.CP-slider'), () => {
    const $wrapper = $('.CP-slider-slick');
    const settings_d = {
        nextArrow: '.CP-slider-btn-right',
        prevArrow: '.CP-slider-btn-left',
        dots: false,
        variableWidth: true,
        slidesToShow: 3
    }
    const settings_m = {
        arrows: false,
        dots: false,
        variableWidth: true,
    }
    if (window.innerWidth < 1024) $wrapper.slick(settings_m);
    else $wrapper.slick(settings_d);
})

// window.onresize = () => {
//     if (window.innerWidth > 1024) {
//         if (wrapper.hasClass('slick-initialized')) wrapper.slick('unslick');
//         return
//     }
//     if (!wrapper.hasClass('slick-initialized')) wrapper.slick(settings);
// };


// WEBPACK FOOTER //
// ./src/scripts/components/Slider.js